module.exports = __webpack_public_path__ + "static/media/innerLogo.bdaabf10.png";